export { default } from './Pagination';
export { default as Page } from './Page';
